import { gql } from '@apollo/client';

import { studentAnsweredAssignmentFragment } from '@ts-core/modules/assignments/graphql/fragments';
import { StudentAnsweredAssignment } from '@ts-core/modules/assignments/types';

export interface GetStudentAnsweredAssignmentQueryVariables {
  courseId: string;
  studentId: string;
  assignmentId: string;
}

export interface GetStudentAnsweredAssignmentQueryResult {
  assignment: StudentAnsweredAssignment;
}

export const getStudentAnsweredAssignmentQuery = gql`
  query GetStudentAnsweredAssignment($courseId: String!, $studentId: String!, $assignmentId: String!) {
    assignment(courseId: $courseId, studentId: $studentId, assignmentId: $assignmentId)
      @rest(type: "StudentAnsweredAssignment", path: "courses/{args.courseId}/students/{args.studentId}/assignments/{args.assignmentId}") {
      ...StudentAnsweredAssignment
    }
  }
  ${studentAnsweredAssignmentFragment}
`;
